// extracted by mini-css-extract-plugin
export default {"item":"Item_item__c165-","item-name":"Item_item-name__5ns7j"};